module.exports = __webpack_public_path__ + "img/MES7Indice3.a9d1c3da.png";